<template>
  <div class="container-warp">
    <Top-Nav pageTitle="用户登录"
             :leftArrow="false"></Top-Nav>
    <!-- <div class="title">JY考试系统</div> -->
    <van-form label-width="50px"
              label-align="right"
              @submit="handleLogin">
      <van-cell-group class="field-box"
                      inset>
        <van-field v-model="loginForm.idCard"
                   required
                   size="large"
                   name="idCard"
                   label="考号"
                   placeholder="请输入考号"
                   :rules="[{ required: true, message: '考号不能为空' }]" />
        <van-field v-model="loginForm.userName"
                   required
                   size="large"
                   type="text"
                   name="userName"
                   label="姓名"
                   placeholder="请输入姓名"
                   :rules="[{ required: true, message: '姓名不能为空' }]" />
        <!-- <van-field v-model="loginForm.imageCode"
                   required
                   size="large"
                   name="imageCode"
                   label="验证码"
                   placeholder="请输入验证码"
                   :rules="[{ required: true, message: '验证码不能为空' }]">
          <template #extra>
            <img :src="codeUrl"
                 class="img-code"
                 title="点击重新获取"
                 @click="getCode" />
          </template>
        </van-field> -->
      </van-cell-group>

      <div class="btn-box">
        <van-button block
                    type="info"
                    size="large"
                    native-type="submit">登 录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getKeys, getCodeImg } from "@/api/login";
// import smCrypto from "sm-crypto";
// const sm2 = smCrypto.sm2;
import store from '@/store';
export default {
  name: "login",
  data() {
    return {
      checkbox: false,
      loginForm: {
        userName: "",
        imageCode: "",
        imageKey: "",
        idCard: "",
      },
      codeUrl: "",
      pubkeys: "",
    };
  },
  created() {
    this.handleLoginBefore();
    this.getCode();
    this.handleGetKeys();
    // webuni.redirectTo({ // eslint-disable-line
    //       url: `/pages/home/home`
    //     });
  },
  methods: {
    ...mapActions(["Login"]),
    // 获取图形验证码
    getCode() {
      getCodeImg().then((res) => {
        let { data } = res;
        this.codeUrl = "data:image/gif;base64," + data.imageBase64;
        this.loginForm.imageKey = data.key;
      });
    },
    // 获取公钥
    async handleGetKeys() {
      const { status, data } = await getKeys();
      if (status == 200) {
        this.pubkeys = data;
      }
    },
    // 登录前判断是否有账号密码
    handleLoginBefore() {
      const userName = localStorage.getItem('userName')
      // const password = localStorage.getItem('password')
      const idCard = localStorage.getItem('idCard')
      if (userName && idCard) {
        this.loginForm.userName = userName
        this.loginForm.idCard = idCard
      }
    },
    // 登录
    async handleLogin() {
      // const { loginForm, pubkeys } = this;
      const { loginForm } = this;
      let params = { ...loginForm };
      params.authMethod = 3
      // params.password = "04" + sm2.doEncrypt(params.password, pubkeys, 1);
      // console.log(params)
      try {
        const { status, errors,data } = await this.Login(params);
        if (status == 200) {
          localStorage.setItem('userName', loginForm.userName)
          // localStorage.setItem('password', loginForm.password)
          localStorage.setItem('idCard', loginForm.idCard)
          localStorage.setItem('userInfo', JSON.stringify(data))
          this.$toast({
            message: '登录成功',
            forbidClick: true,
          })
          store.dispatch('GetInfo',data).then((res) => {
            webuni.postMessage({ // eslint-disable-line
              data: {
                type: '登录成功',
                data: res,
                token: data.token
              }
            });
            const h5data = {
              userInfo: res,
              token: data.token
            }
            // 登录完成后跳转中转页面将用户信息传递给中转页面
            webuni.redirectTo({ // eslint-disable-line
              url: `/pages/iplpsIndex/iplpsIndex?loginInfo=${JSON.stringify(h5data)}`
            });
            // this.$router.push({ path: "/index" }); // 跳转到首页
          })
          
        } else {
          const errMsg = errors[0].message;
          this.$toast({
            message: errMsg,
            forbidClick: true,
          });
          if (errMsg !== "验证码不正确！") {
            this.getCode();
          }
        }
      } catch (error) {
        console.log(error)
         this.getCode();
      }
    },
    // 跳转页面
    jumpPage(path) {
      this.$router.push({ path });
    }
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  margin: 30px 0;
  text-align: center;
}
.field-box {
  padding-top: 16px;
  padding-bottom: 6px;
}
.forget-password {
  color: #409eff;
}
.btn-box {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  margin-top: 36px;
  .van-button {
    margin-bottom: 10px;
  }
}
.img-code {
  width: 100px;
  height: 30px;
  cursor: pointer;
}
</style>